import React, { useState } from 'react';
import { CustomIcon } from 'modules/components/layer00';
import { SaveDocumentModal } from 'modules/components/layer17';
import { menuUtil } from 'modules/common';

import {
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';



export type DocumentMenuProps = menuUtil.IBaseMenuProps & {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DocumentMenuProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
      >

        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsVisible(() => true);
          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='EDITALT'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
            >
              Edit
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {isVisible && (
        <SaveDocumentModal.FC
          id={props.id}
          isVisible={isVisible}
          handleClose={() => {
            props.handleClose();
            setIsVisible(() => false);
          }}
        />
      )}
    </>
  );
};
